import { Gift } from "lucide-react";
import type { CheckinSlot } from "@/lib/boide-api";

const vnd = (n: number) => n.toLocaleString("vi-VN");
// Rút gọn cho ô chật: 1000 → "1K", 5000 → "5K".
const shortReward = (n: number) => (n % 1000 === 0 ? `${n / 1000}K` : vnd(n));

/** Lưới 7 ngày của chu kỳ điểm danh — dùng chung cho trang & popover header. */
export function CheckinCycle({
  cycle,
  compact = false,
}: {
  cycle: CheckinSlot[];
  compact?: boolean;
}) {
  return (
    <div
      className={`grid ${compact ? "grid-cols-7 gap-1" : "app-checkin-cycle grid-cols-4 gap-2 sm:grid-cols-7"}`}
    >
      {cycle.map((slot) => (
        <div
          key={slot.day}
          className={`flex min-w-0 flex-col items-center justify-between gap-1.5 rounded-xl border text-center transition ${
            compact ? "px-0.5 py-2" : "px-1 py-2.5"
          } ${
            slot.claimed
              ? "border-primary/60 bg-gold-gradient/10"
              : "border-border/50 bg-background/40"
          } ${slot.is_bonus ? "ring-1 ring-primary/50" : ""}`}
        >
          <span className="text-[9px] leading-tight text-muted-foreground md:text-[10px]">
            {compact ? `N${slot.day}` : `Ngày ${slot.day}`}
          </span>
          {slot.is_bonus ? (
            <Gift
              className={`h-4 w-4 shrink-0 ${slot.claimed ? "text-primary" : "text-muted-foreground"}`}
            />
          ) : (
            <span
              className={`text-base leading-none ${slot.claimed ? "text-primary" : "text-muted-foreground/70"}`}
            >
              ◎
            </span>
          )}
          <span
            className={`w-full truncate text-[10px] font-semibold leading-none ${slot.is_bonus ? "text-primary" : "text-foreground/70"}`}
          >
            {compact ? shortReward(slot.reward) : `${vnd(slot.reward)}đ`}
          </span>
        </div>
      ))}
    </div>
  );
}
